export default {
  displayOptionCommission: '顯示佣金詳情',
  displayOptionCommissionLevelV: '顯示佣金等級',
  displayOptionCommissionLevelH: '顯示等級(豎)',
  searchTitle: '篩選區',
  schoolName: '院校名稱',
  schoolNationality: '國家/地區',
  schoolProvince: '省份',
  schoolCity: '城市',
  courseLevel: '課程等級',
  searchContent: '請輸入搜索內容',
  group: '集團',
  schoolType: '學校種類',
  contractNationality: '學生國籍',
  commissionConditionsSearch: '佣金條件',
  filter: '篩選',
  displayLevel: '只顯示等級',
  displaySummary: '顯示概括',
  exportList: '導出列表',
  search: '搜索',
  commissionConditions: '佣金條件',
  agentCommission: '代理佣金',
  agentMktFee: '市場費用',
  agentMktFeeRemark: '市場費用備註',
  agentCommissionRemark: '代理佣金備註',
  agentFollowCommission: '後續佣金',
  agentFollowCommissionRemark: '後續佣金備註',
  agentProgramTW: 'Programmes',
  agentProgramTWDirect: 'Direct',
  agentProgramTWPush: 'Push',
  agentProgramHK: 'Promotion',
  agentProgramHints: 'For UK UG/PG Students, special marketing rate will be offered if 2 or more students enrolled to our UK Universities.',
  dataTotalNumber: '共{totalNumber}條數據 ({totalSchool}所學校)',
  hot: '熱搜',
  new: '最新',
  newDays: '天',
  serialNumber: '序號',
  country: '國家/省份/城市',
  operation: '操作',
  commissionRate: '佣金',
  institutionName: '院校名稱',
  searchResultEmpty: '請更改搜尋',
  searchResultSameCountry: '本地學生不能獲得佣金，請更改搜尋',
  noPermission: '無權訪問， 請聯絡管理員。',
  mpsList: '佣金列表',
  naText: '沒有指定',
  recommend: '推薦',
  common: '常見',
  recommendTips: '數據按熱門排序',
  commonTips: '數據按申請數量排序',
  otherTips: '數據按學校名稱排序',
  commonNoDataTips: '沒有常見，可使用推薦',
  remarkMPSTips: '註：實際收益以學校更新政策及實際到帳為準，GEA保留最終解釋權。',
  countryTips: "屬於中國境外學生：請在篩選器中選擇對應國家，或諮詢您的BD經理。",
}